import { getField, updateField } from 'vuex-map-fields';
import apiAxios from '../../services/apiAxios';
import moment from 'moment';
import helpers from '../../mixins/helpers';

const state = {
    impuestos: false,
    controller: '',

    cuentaCorriente: [],
    /* Paginacion */
    paginaActual: 1,
    registrosPorPagina: 10,
    totalRegistros: 0,
    totalPaginas: 0,
    /* Filtro */
    fechaDesde: moment(new Date()).add(-30, 'days').format('YYYY-MM-DD'),
    fechaHasta: moment(new Date()).format('YYYY-MM-DD'),
    proveedor: null,

    rptCuentaCorriente: [],
    rptDeuda: [],
    rptPlazos: [],
};

const mutations = {
    updateField,

    'INICIALIZAR_OPCIONES'(state) {
        state.impuestos = false;

        state.cuentaCorriente = [];
        /* Opciones de filtro y paginacion */
        state.paginaActual = 1;
        state.registrosPorPagina = 10;
        state.totalRegistros = 0;
        state.totalPaginas = 0;

        state.fechaDesde = moment(new Date()).add(-30, 'days').format('YYYY-MM-DD');
        state.fechaHasta = moment(new Date()).format('YYYY-MM-DD');
        state.proveedor = null;
    },

    'INICIALIZAR_CUENTA_CORRIENTE' (state, impuestos) {
        if (state.impuestos != impuestos) {
            state.fechaDesde =  moment(new Date()).add(-30, 'days').format('YYYY-MM-DD');
            state.fechaHasta =  moment(new Date()).format('YYYY-MM-DD');
            state.proveedor = null;
            state.paginaActual = 1;
        }

        if (impuestos) {
            state.controller = 'cuentacorrienteimpuestos';
        } else {
            state.controller = 'cuentacorrienteproveedores';
        }
        
        state.impuestos = impuestos;

        state.cuentaCorriente = [];

    },
    'SET_CUENTA_CORRIENTE' (state, cuentaCorriente) {
        state.cuentaCorriente = cuentaCorriente;
    },
    'SET_PAGINATION'(state, params) {
        state.paginaActual = params.paginaActual;
        state.registrosPorPagina = params.registrosPorPagina;
        state.totalRegistros = params.totalRegistros;
        state.totalPaginas = params.totalPaginas;
    },

    'INICIALIZAR_RPT' (state) {
        state.rptCuentaCorriente = [];
    },
    'SET_RPT' (state, rptCuentaCorriente) {
        state.rptCuentaCorriente = rptCuentaCorriente;
    },
    'INICIALIZAR_RPT_DEUDA' (state) {
        state.rptDeuda = [];
    },
    'SET_RPT_DEUDA' (state, rptDeuda) {
        state.rptDeuda = rptDeuda;
    },
    'INICIALIZAR_RPT_PLAZOS' (state) {
        state.rptPlazos = [];
    },
    'SET_RPT_PLAZOS' (state, rptPlazos) {
        state.rptPlazos = rptPlazos;
    },
};

const getters = {
    getField,

    rptCuentaCorriente(state) {
        return state.rptCuentaCorriente;
    },
    rptDeuda(state) {
        return state.rptDeuda;
    },
    rptPlazos(state) {
        return state.rptPlazos;
    }
};

const actions = {
    inicializarOpciones ( { commit } ) {
        commit('INICIALIZAR_OPCIONES');
    },
        
    getCuentaCorriente ( { commit, state }, impuestos ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_CUENTA_CORRIENTE', impuestos);

            let queryString = '?fechaDesde='+ moment(state.fechaDesde).format('YYYY-MM-DD')
                + '&fechaHasta='+ moment(state.fechaHasta).format('YYYY-MM-DD');
            
            if (state.paginaActual != 0) {
              queryString += '&pageSize=' + state.registrosPorPagina
                + '&pageNumber=' + state.paginaActual
            }
            if (state.proveedor) {
                if (state.proveedor.id != 0) {
                    queryString += '&proveedorId=' + state.proveedor.id;
                }
            }
            
            apiAxios.get(state.controller + '/resumen' + queryString)
                .then(res => {
                    if (res.headers.pagination){
                        const pagination= JSON.parse(res.headers.pagination)
                        var params = {
                            paginaActual: pagination.currentPage,
                            registrosPorPagina: pagination.itemsPerPage,
                            totalRegistros: pagination.totalItems,
                            totalPaginas: pagination.totalPages,
                        }    
                        commit('SET_PAGINATION', params);
                    }
                    commit('SET_CUENTA_CORRIENTE', res.data);

                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })            
    },
    getRptCuentaCorriente ( { commit, state } ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_RPT');

            let queryString = '?fechaDesde='+ moment(state.fechaDesde).format('YYYY-MM-DD')
                + '&fechaHasta='+ moment(state.fechaHasta).format('YYYY-MM-DD');
                
            if (state.proveedor) {
                if (state.proveedor.id != 0) {
                    queryString += '&proveedorId=' + state.proveedor.id;
                }
            }
                
            apiAxios.get(state.controller + '/resumen/export' + queryString)
                .then(res => {
                    commit('SET_RPT', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })            
    },
    getRptDeuda ( { commit }, params ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_RPT_DEUDA');

            let queryString = '?fechaDesde='+ moment(params.fechaDesde).format('YYYY-MM-DD')
                + '&fechaHasta='+ moment(params.fechaHasta).format('YYYY-MM-DD');
        
            if (params.proveedorId != 0) {
                queryString += '&proveedorId=' + params.proveedorId;
            }

            apiAxios.get('cuentacorrienteproveedores/rpt/deuda' + queryString)
                .then(res => {
                    commit('SET_RPT_DEUDA', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })            
    },
    getRptPlazos ( { commit }, params ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_RPT_PLAZOS');

            let queryString = '?fechaDesde='+ moment(params.fechaDesde).format('YYYY-MM-DD')
                + '&fechaHasta='+ moment(params.fechaHasta).format('YYYY-MM-DD');
        
            if (params.proveedorId != 0) {
                queryString += '&proveedorId=' + params.proveedorId;
            }

            apiAxios.get('cuentacorrienteproveedores/rpt/plazos' + queryString)
                .then(res => {
                    commit('SET_RPT_PLAZOS', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })            
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}